import apiFetch from '../apiFetch'

export default function (token, fleetChargeId) {
  return apiFetch({ endPoint: `DocumentFleetChargeInfo/${fleetChargeId}/info`, method: 'GET', body: null, token: token })
}
